module.exports = __webpack_public_path__ + "media/icons/star_empty-22d6a64e.svg";